import {travianCurrentServer} from "../travianCore.js";

/**
 * @param targetMapId map id of the target
 * @param sourceVillageId village id of the source
 * @param eventType type of event
 * @param troops {{ t1, t2, t3, t4, t5, t6, t7, t8, t9, t10 }}
 * @param targetX
 * @param targetY
 * @returns {string}
 */
export function linkToSendAttack({ targetMapId, sourceVillageId, eventType, troops, targetX, targetY }) {
    const args = {
        id: 39,
        tt: 2,
        targetMapId,
        x: targetX,
        y: targetY,
        eventType: eventType ?? 3,
        newdid: sourceVillageId,
        ...Object.entries(troops ?? []).reduce((total, [key, value]) => {
            total[`troop[${key}]`] = value;
            return total;
        }, {}),
    };
    for (const key in args) {
        if (args[key] === undefined) {
            delete args[key];
        }
    }
    return `https://${travianCurrentServer}/build.php?${new URLSearchParams(args).toString()}`;
}
